import React, {Fragment} from 'react'
import styled from 'styled-components'

const OpenClose = styled.div`
  cursor: pointer;
  margin: 10px 0 10px 2px;
  
`
const FileIcon = styled.a`
  display: inline;
  color: #dd6a01;
  font-size: 10pt;
`

const Icon = styled.i`
  margin-right: 5px;
`

const Caret = styled.i`
  margin-left: 3px;
`
export default class TaxReturns extends React.Component {
  constructor() {
    super()
    this.state = {
      isOpen: false
    }
  }
  toggleOpen = () => {
    this.setState({ isOpen: !this.state.isOpen })
  }
  renderLinks = () => {
    if (this.state.isOpen) {
      const { taxReturnUrls } = this.props.entity
      return taxReturnUrls.slice().reverse().map(tr => {
        return (
          <div key={`${tr.value}-${tr.label}`}>
            <FileIcon
              href={tr.value}
              target="_blank"
              rel="noreferrer"
              id={`${tr.label}_tax_return_document`}
            >
              <Icon className="fa fa-file-text-o" />
              {tr.label} Tax Return
            </FileIcon>
          </div>
        )
      })
    }
  }
  render() {
    const { name } = this.props.entity
    const { isOpen } = this.state
    return (
      <Fragment>
        <OpenClose onClick={this.toggleOpen}>
          View {name}'s Tax Returns
          <Caret className={`fa fa-caret-${isOpen ? 'down' : 'up'}`} />
        </OpenClose>
        { this.renderLinks() }
      </Fragment>
    )
  }
}